import { observer } from "mobx-react-lite"
import { useContext, useEffect, useLayoutEffect, useRef, useState } from "react";
import ExpensesAPI from "../API/ExpensesAPI";
import { ReactComponent as Plus } from "../images/icons/plus.svg";
import { ReactComponent as Find } from "../images/icons/find.svg";
import { ReactComponent as Filter } from "../images/icons/filter.svg";
import ExpenseCard from "../components/lists/expenseCard";
import { Context } from "..";
import useNotification from "../hooks/useNotification";

const Expenses = () => {
    const { error } = useNotification();
    const { store } = useContext(Context);
    const [contextMenu, setContextMenu] = useState(null);
    const [selectedItem, setSelectedItem] = useState(null);

    const [objects, setObjects] = useState([]);
    const [newCell, setNewCell] = useState(null);
    const [summ, setSumm] = useState();

    useEffect(() => {
        loadData().then(() => console.log("Список расходов загружен"));
    }, []);
    useLayoutEffect(() => {
        if (!objects) return;
        let expensesSumm = 0;
        for (let i = 0; i < objects.length; i++) {
            expensesSumm += objects[i].cost;
        }
        setSumm(expensesSumm);
    }, [objects]);
    const loadData = async () => {
        try {
            const response = await ExpensesAPI.getAll();
            if (response.status !== 200) throw response;
            setObjects(response.data);
            return response.data;
        } catch (err) {
            console.log("[x] Ошибка загрузки расходов:", err);
            return [];
        }
    }

    // Редактирование статьи расходов
    const setValue = async (index, newValue, field) => {
        let oldArr = [...objects];
        oldArr[index] = {...objects[index], [field]: newValue};
        setObjects(oldArr);
    }
    const removeValue = async (index) => {
        try {
            let newObjects = objects;
            if (!newObjects[index].id) newObjects = await loadData();
            const response = await ExpensesAPI.remove(newObjects[index].id);
            if (response.status !== 200) throw response;

            newObjects = newObjects.filter((item, itemIndex) => itemIndex !== index);
            setObjects([...newObjects]);
        } catch (err) {
            console.log("[x] Ошибка удаления статьи расхода:", err);
            error("Ошибка удаления статьи расхода");
        }
    }
    const saveValue = async (value) => {
        try {
            const response = await ExpensesAPI.update(value);
            if (response.status !== 200) throw response;
        } catch (err) {
            console.log("[x] Ошибка обновления статьи расхода:", err);
            error("Ошибка сохранения статьи расхода");
        }
    }
    // Создание новой статьи расходов
    const addingValue = () => {
        setNewCell({ 
            name: "", 
            cost: 0 
        });
    }
    const setValueNewCell = (value, field) => {
        let newValue = newCell;
        newValue[field] = value;
        setNewCell({ ...newValue });
    }
    const saveNewCell = async (value) => {
        try {
            const response = await ExpensesAPI.create(value);
            if (response.status !== 200) throw response;

            let newObjects = await loadData();
            setObjects(newObjects);
            setNewCell(null);
        } catch (err) {
            console.log("[x] Ошибка создания статьи расходов:", err);
            error("Ошибка создания статьи расходов");
        }
    }

    const formatNumber = (num) => {
        if (!num) return 0;
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    }

    return (
        <div className="setupBlock">
            <div className="setupBigContent big" style={{ paddingTop: "40px" }}>
                <div className="title big" style={{ padding: "0 20px" }}>
                    <div className="text">Таблица расходов</div>
                    <div className="summ">
                        <div className="text">Итого:</div>
                        <div className="value">{formatNumber(summ)} ₽</div>
                    </div>
                </div>
                <div className="tableContainer">
                    <div className="tableSettings">
                        <div className="left_side"></div>
                        <div className="right_side">
                            <button className="defaultButton disabled"><Filter/></button>
                            <button className="defaultButton disabled"><Find/></button>
                            {store.userInfo && store.userInfo.isLicensed == true && <button className="activeButton" onClick={addingValue}>Добавить <Plus/></button>}
                        </div>
                    </div>
                    <div className="tableHeader">
                        <div className="left">
                            <div className="num">№ п/п</div>
                            <div className="name">Наименование</div>
                        </div>
                        <div className="right">
                            <div>В месяц</div>
                            <div>В год</div>
                            <div>Удалить</div>
                        </div>
                    </div>
                    <div className="setupCardTable">
                        <ul className="list">
                            {objects.map((item, index) => <ExpenseCard
                                value={item}
                                setValue={(newValue, field) => setValue(index, newValue, field)}
                                onDelete={() => removeValue(index)}
                                saveValue={(newValue) => saveValue(newValue)}
                                index={objects.length - index - 1}
                                key={item+index}
                            />)}
                            {newCell && <ExpenseCard 
                                value={newCell} 
                                setValue={(newValue, field) => setValueNewCell(newValue, field)}
                                saveValue={(value) => saveNewCell(value)}
                                onDelete={() => setNewCell(null)}
                                index={-1}
                                isNew={true}
                            /> }
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default observer(Expenses);
